const LIST = 'modules_list';
const LIST_FILTERED = 'modules_list_filtered';

export {
  LIST,
  LIST_FILTERED,
}


// WEBPACK FOOTER //
// ./src/redux/actions/types/modulesTypes.js